export default __webpack_public_path__ + "static/media/wristwraps_of_the_doomsayer.dbc165f9.jpg";